import Num2Persian from '@/api/Num2Persian';
import JDate from 'jalali-date';
import HttpErrorToSnackbar from '@/api/HttpErrorToSnackbar';
export default {
  methods: {
    AuthToken: function () {
      return localStorage.getItem('default_auth_token');
    },
    toJalali: function (jd, time) {
      if (typeof time === 'undefined') {
        time = true;
      }
      // 2019-07-08T10:54:22+04:30
      let splittedDate = jd.split('T');
      let date_1 = splittedDate[0].split('-');
      const d = new JDate(new Date(date_1[0], (parseInt(date_1[1], 10) - 1), date_1[2]));
      return this.toPersianDigit(d.format('YYYY/MM/DD') + (time ? '  ' + splittedDate[1].replace('+04:30', '', -1).replace('+03:30', '', -1) : ''));
    },
    toPersianDigit: function (input, toEnglish) {
      if (typeof input !== 'string') {
        input = input.toString();
      }
      let dg = [
        ['۰', '0'],
        ['۱', '1'],
        ['۲', '2'],
        ['۳', '3'],
        ['۴', '4'],
        ['۵', '5'],
        ['۶', '6'],
        ['۷', '7'],
        ['۸', '8'],
        ['۹', '9']
      ];
      if (typeof toEnglish === 'undefined') {
        toEnglish = false;
      }
      if (toEnglish) {
        for (let i = 0; i <= 9; i++) {
          input = input.replace(new RegExp(dg[i][0], 'g'), dg[i][1]);
        }
        return input;
      }
      for (let i = 0; i <= 9; i++) {
        input = input.replace(new RegExp(dg[i][1], 'g'), dg[i][0]);
      }
      return input;
    },
    moneyFormat: function (str, ignorePersianChar) {
      if (typeof ignorePersianChar === 'undefined') {
        ignorePersianChar = false;
      }
      let minus = '';
      str = parseInt(str, 10);
      if (str < 0) {
        minus = '-';
        str = Math.abs(str);
      }
      let arr = str.toString().split('').reverse();
      let out = [];
      let i = 0;
      arr.forEach(a => {
        if (i % 3 === 0 && i > 0) {
          out.push('،');
        }
        out.push(a);
        i++;
      });
      if (ignorePersianChar) {
        return minus + out.reverse().join('');
      }
      return minus + this.toPersianDigit(out.reverse().join(''), false);
    },
    toPersian: function (v) {
      return Num2Persian(Math.floor(v / 10)) + ' تومان';
    },
    DeleteEntity: function (entity, id) {

      this.$confirm('آیا از حذف این مورد اطمینان دارید؟').then(res => {
        if (res) {
          this.axios.delete('/reseller/' + entity + '/' + id)
            .then(response => {
              this.snackbar.snackbar = true;
              this.snackbar.color = 'success';
              this.snackbar.text = response.data.messages.join(' ');
            })
            .catch(error => {
              this.snackbar = HttpErrorToSnackbar(error);
            });
        }
      });
    },
    DeleteEntityPromise: function (entity, id) {
      return new Promise((resolve, reject) => {
        this.$confirm('آیا از حذف این مورد اطمینان دارید؟').then(res => {
          if (res) {
            this.axios.delete('/reseller/' + entity + '/' + id)
              .then(response => {
                this.snackbar.snackbar = true;
                this.snackbar.color = 'success';
                this.snackbar.text = response.data.message;
                resolve();
              })
              .catch(error => {
                this.snackbar = HttpErrorToSnackbar(error);
                reject(error);
              });
          }
        });
      });
    },
    showAlarm: function (alarm) {
      this.snackbar.snackbar = true;
      this.snackbar.color = 'purple';
      this.snackbar.text = alarm;
    },
    clearBasket: function (id) {
      this.$confirm('تایید و تسویه‌ی بدهی').then(res => {
        if (res) {
          this.axios.post('/reseller/clear_basket/' + id)
            .then(response => {
              this.snackbar.snackbar = true;
              this.snackbar.color = 'success';
              this.snackbar.text = 'با موفقیت انجام شد!';
            })
            .catch(error => {
              this.snackbar = HttpErrorToSnackbar(error);
            });
        }
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/globals.js